import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import CustomSelect from "../../../common/customSelect";
import {
  CUSTOM_SELECT_COLOR_BLUE,
  CUSTOM_SELECT_COLOR_WHITE,
} from "../../../common/customSelect/constants";
import "../../../hb/results/results.scss";

const ESTADOS = [
  { id: "", name: "Todos" },
  { id: "GESTIÓN INICIADA", name: "Gestión iniciada" },
  { id: "EN PROCESO", name: "En proceso" },
  { id: "GESTIÓN EN SEGUIMIENTO", name: "Gestión en seguimiento" },
  { id: "APROBADO", name: "Aprobado" },
  { id: "RECHAZADO POR FINANCIADOR", name: "Rechazado por financiador" },
];

const HeaderFilters = ({
  filtroTexto,
  filtroEstado,
  familyGroupList,
  familyItem,
  setFiltroTexto,
  setFiltroEstado,
  onChangePaciente,
}) => {
  const [estadoLabel, setEstadoLabel] = useState("Todos");
  const [closeEstado, setCloseEstado] = useState(false);
  const [closePaciente, setClosePaciente] = useState(false);

  const onChangeEstado = (id, _selectName, text) => {
    setFiltroEstado(id);
    setEstadoLabel(text);
  };

  return (
    <div className="row">
      <div className="item-1" id="findUserName">
        <div className="input-icons me-3" style={{ position: "relative" }}>
          <FontAwesomeIcon icon={faSearch} className="custom-icon-results" />
          <input
            value={filtroTexto}
            className="input-field-results"
            type="text"
            placeholder="Buscar"
            onChange={(e) => setFiltroTexto(e.target.value)}
            onClick={() => { setCloseEstado(true); setClosePaciente(true); }}
          />
        </div>
      </div>

      <div className="item-2 col-years-results">
        <div id="title-study-results" style={{ width: "80px" }}>
          <span className="año-estudio">Estado</span>
        </div>
        <div style={{ position: "relative", width: "190px" }}>
          <CustomSelect
            close={closeEstado}
            defaultText={estadoLabel}
            optionsList={ESTADOS}
            type={CUSTOM_SELECT_COLOR_WHITE}
            onChange={onChangeEstado}
            onClick={() => { setClosePaciente(true); setCloseEstado(false); }}
            width="190px"
            name="estado"
            paddingTop="1rem"
            fontFamily="Roboto-Regular"
          />
        </div>
      </div>

      <div className="item-3" style={{ marginBottom: "0rem" }}>
        <div id="dropdown-name" style={{ position: "relative", maxWidth: "250px" }}>
          <CustomSelect
            defaultText={familyItem}
            optionsList={familyGroupList ?? [{ id: "", name: "" }]}
            type={CUSTOM_SELECT_COLOR_BLUE}
            width="100%"
            name="paciente"
            onChange={onChangePaciente}
            onClick={() => { setCloseEstado(true); setClosePaciente(false); }}
            fontFamily="Roboto-Regular"
            close={closePaciente}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderFilters;
